import * as React from 'react';
import { formatLanguage } from './formatter';

interface CodeState {
  isMultiLanguage: boolean;
  languages: string[];
  active?: string;
}

const initialState = {
  isMultiLanguage: false,
  languages: [],
};

const CodeContext = React.createContext<{
  state: CodeState;
  setState: React.Dispatch<React.SetStateAction<CodeState>>;
}>({ state: initialState, setState: () => {} });

export const CodeBlock = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = React.useState<CodeState>(initialState);

  return (
    <CodeContext.Provider value={{ state, setState }}>
      <div className="multi-language">
        {state.languages?.length > 1 ? (
          <div className="language-picker">
            {state?.languages.map((l) => (
              <button
                key={l}
                className={l === state.active ? 'active' : undefined}
                onClick={() => setState((s) => ({ ...s, active: l }))}>
                {formatLanguage(l)}
              </button>
            ))}
          </div>
        ) : null}
      </div>
      {children}
    </CodeContext.Provider>
  );
};

export function useCodeBlock() {
  const {
    state: { active, isMultiLanguage, languages },
    setState,
  } = React.useContext(CodeContext);

  function registerLanguage(l: string) {
    if (!languages?.includes(l)) {
      setState((s) => ({
        active: s.active ?? l,
        isMultiLanguage: languages ? true : false,
        languages: [...(s?.languages ?? []), l],
      }));
    }
  }

  return {
    isMultiLanguage,
    languages,
    registerLanguage,
    active,
  };
}
